export const SpanishBanks = [
  { value: 'Abanca', display: 'Abanca', supervisorCode: '2080' },
  { value: 'Banc Sabadell', display: 'Banc Sabadell', supervisorCode: '0081' },
  { value: 'Banco Popular', display: 'Banco Popular', supervisorCode: '3159' },
  { value: 'Banco Pueyo', display: 'Banco Pueyo', supervisorCode: '0078' },
  { value: 'Bankinter', display: 'Bankinter', supervisorCode: '0128' },
  { value: 'BBVA', display: 'BBVA', supervisorCode: '0182' },
  { value: 'Caixabank', display: 'Caixabank', supervisorCode: '2100' },
  { value: 'Caja de Ingenieros', display: 'Caja de Ingenieros', supervisorCode: '3025' },
  { value: 'Caja Rural de Extremadura', display: 'Caja Rural de Extremadura', supervisorCode: '3009' },
  { value: 'Caja Rural de Granada', display: 'Caja Rural de Granada', supervisorCode: '3023' },
  { value: 'Cajamar', display: 'Cajamar', supervisorCode: '3058' },
  { value: 'Deustsche bank', display: 'Deutsche bank, AG', supervisorCode: '0145' },
  { value: 'Deustsche bank', display: 'Deutsche bank, SA', supervisorCode: '0019' },
  { value: 'EVO Banco', display: 'EVO Banco', supervisorCode: '0239' },
  { value: 'Grupo Caja Rural', display: 'Grupo Caja Rural', supervisorCode: '3187' },
  { value: 'Grupo Cooperativo Cajamar', display: 'Grupo Cooperativo Cajamar', supervisorCode: '3058' },
  { value: 'Ibercaja', display: 'Ibercaja', supervisorCode: '2085' },
  { value: 'Bankia', display: 'Bankia', supervisorCode: '2038' },
  { value: 'ING Direct', display: 'ING Direct', supervisorCode: '1465' },
  { value: 'Kutxabank', display: 'Kutxabank', supervisorCode: '2095' },
  { value: 'LiberBank', display: 'LiberBank', supervisorCode: '2048' },
  { value: 'OpenBank', display: 'OpenBank', supervisorCode: '0073' },
  { value: 'Santander', display: 'Santander', supervisorCode: '0049' },
  { value: 'Selfbank', display: 'Selfbank', supervisorCode: '1490' },
  { value: 'Targobank', display: 'Targobank', supervisorCode: '0216' },
  { value: 'Triodos', display: 'Triodos', supervisorCode: '1491' },
  { value: 'Unicaja', display: 'Unicaja', supervisorCode: '2103' },
];
